export { default } from './FormPageBlogPost.vue'
